import { createAction } from 'redux-act'
import RegisterService from 'services/register'
import * as app from './app'

export const REDUCER = 'register'
const NS = `@@${REDUCER}/`

export const checkCnpjStatus = createAction(`${NS}CNPJ_CHECK_STATUS`)
export const checkCnpjStatusStrict = createAction(`${NS}CNPJ_CHECK_STATUS_STRICT`)
export const checkCnpjError = createAction(`${NS}CNPJ_CHECK_ERROR`)
export const checkCnpjAlreadyError = createAction(`${NS}CNPJ_CHECK_ERROR_ALREADY`)
export const checkEmailStatus = createAction(`${NS}EMAIL_CHECK_STATUS`)
export const checkEmailStatusStrict = createAction(`${NS}EMAIL_CHECK_STATUS_STRICT`)
export const checkEmailError = createAction(`${NS}EMAIL_CHECK_ERROR`)
export const registerSuccess = createAction(`${NS}REGISTER_SUCCESS`)
export const resetRegister = createAction(`${NS}RESET`)

export const checkCnpj = (cnpj) => {
  return async (dispatch, getState) => {
    await dispatch(checkCnpjStatus('validating'))
    RegisterService
      .checkCnpj(cnpj)
      .then((result) => {
        if (result.data.hasOwnProperty('continue')) {
          return dispatch(checkCnpjStatus(result.data.continue ? 'success' : 'error'))
        }

        dispatch(checkCnpjError())
      })
      .catch((error) => {
        if(error.response && error.response.status === 400){
          dispatch(checkCnpjAlreadyError())
       }else{
         dispatch(checkCnpjError())
       }
      })
  }
}

export const checkEmail = (email) => {
  return async (dispatch, getState) => {
    await dispatch(checkEmailStatus('validating'))
    RegisterService
      .checkEmail(email)
      .then((result) => {
        if (result.data.hasOwnProperty('continue')) {
          return dispatch(checkEmailStatus(result.data.continue ? 'success' : 'error'))
        }

        dispatch(checkEmailError())
      })
      .catch((err) => {
        console.error(err)
        dispatch(checkEmailError())
      })
  }
}

export const registerSubmit = (data) => {
  return async (dispatch, getState) => {
    dispatch(app.addSubmitForm(REDUCER))
    RegisterService
      .register(data)
      .then((result) => {
        if (result.status === 201) {
          dispatch(registerSuccess())
        }
      })
      .catch((error) => {
        if(error.response.status === 400){
          dispatch(checkCnpjAlreadyError())
       }else{
         dispatch(checkCnpjError())
       }
      })
      .then(() => {
        dispatch(app.deleteSubmitForm(REDUCER))
      })
  }
}

const reducer = (state, action) => {
  if (state === undefined) {
    return {
      cnpjCheckMessage: undefined,
      cnpjCheckStatus: undefined,
      emailCheckMessage: undefined,
      emailCheckStatus: undefined,
      registerResult: null
    }
  }

  switch (action.type) {
    case checkCnpjStatus.toString():
      return {
        ...state,
        cnpjCheckStatus: action.payload,
        cnpjCheckMessage: action.payload === 'error' ? 'CPF/CNPJ já cadastrado' : undefined
      }

    case checkCnpjStatusStrict.toString():
      return {
        ...state,
        cnpjCheckStatus: action.payload
      }

    case checkCnpjError.toString():
      return {
        ...state,
        cnpjCheckStatus: 'error',
        cnpjCheckMessage: 'Erro ao consultar CPF/CNPJ, tente novamente mais tarde.'
      }

      case checkCnpjAlreadyError.toString():
      return {
        ...state,
        cnpjCheckStatus: 'error',
        cnpjCheckMessage: 'Erro ao cadastrar, CPF/CNPJ já cadastrado'
      }

    case checkEmailStatus.toString():
      return {
        ...state,
        emailCheckStatus: action.payload,
        emailCheckMessage: action.payload === 'error' ? 'Email já cadastrado' : undefined
      }

    case checkEmailStatusStrict.toString():
      return {
        ...state,
        emailCheckStatus: action.payload
      }

    case checkEmailError.toString():
      return {
        ...state,
        emailCheckStatus: 'error',
        emailCheckMessage: 'Erro ao consultar email'
      }

    case registerSuccess.toString():
      return {
        ...state,
        registerResult: 'success'
      }

    case resetRegister.toString():
      return {
        ...state,
        cnpjCheckMessage: undefined,
        cnpjCheckStatus: undefined,
        emailCheckMessage: undefined,
        emailCheckStatus: undefined,
        registerResult: null
      }

    default:
      return {
        ...state
      }
  }
}

export default reducer
